export default __webpack_public_path__ + "static/media/Resource-Icons-Gifted-Children-transparent.d59f1a1d.png";